import { getShortenedDefaultDurations } from './durationOptionsUtils';
import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';

export default function shouldAdjustStartEndTimeForDuration(
    duration: number,
    viewStateId: string | null
): boolean {
    const { shouldAdjustStartTimeEndTime } = getTimeSuggestionsStore(viewStateId);

    if (shouldAdjustStartTimeEndTime) {
        return getShortenedDefaultDurations().includes(duration);
    }

    return false;
}

export function isPreviousAndCurrentDurationAdjusted(
    previousDuration,
    currentDuration,
    viewStateId
): boolean {
    const { shouldAdjustStartTimeEndTime } = getTimeSuggestionsStore(viewStateId);

    const shortenedDefaultDurations = getShortenedDefaultDurations();
    if (shouldAdjustStartTimeEndTime) {
        return (
            shortenedDefaultDurations.includes(previousDuration) &&
            shortenedDefaultDurations.includes(currentDuration)
        );
    }

    return false;
}
